import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'jsonArrayJoin' })
export class JsonArrayJoinPipe implements PipeTransform {
  transform(value: string, separator: string = ', '): string {
    try {
      const arr = JSON.parse(value);
      return Array.isArray(arr) ? arr.join(separator) : value;
    } catch {
      return value;
    }
  }
}
